import { Popover, PopoverButton } from "@headlessui/react"
import { EyeOff } from "lucide-react"
import { ReactNode } from "react"

import { Button } from "../../../../components/base/control/Button"
import PopoverPanel from "../../../../components/base/overlay/Popover/PopoverPanel"

interface TableHeaderCellHideShowProps {
  children: ReactNode
  onToggleColumnHideShow: () => void
}

export function TableHeaderCellHideShow({
  children,
  onToggleColumnHideShow,
}: TableHeaderCellHideShowProps) {
  return (
    <Popover as="div" className="h-full w-full">
      {({ close }) => (
        <>
          <PopoverButton as="div" className="flex h-full w-full items-center">
            {children}
          </PopoverButton>
          <PopoverPanel className="flex w-40 flex-col p-2">
            <Button
              mode="ghost"
              leftIcon={EyeOff}
              className="justify-start focus:ring-0"
              size="small"
              onClick={() => {
                onToggleColumnHideShow()
                close()
              }}
            >
              Hide field
            </Button>
          </PopoverPanel>
        </>
      )}
    </Popover>
  )
}
